import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-wrap items-center gap-2 border-b border-gray-200 bg-[#f9fafb] px-3 py-2.5" }
const _hoisted_2 = { class: "inline-grid h-7 w-7 flex-shrink-0 place-items-center rounded-full bg-[#fef3c7] text-[#b45309]" }
const _hoisted_3 = { class: "text-sm font-semibold text-gray-800" }
const _hoisted_4 = { class: "flex flex-col gap-3 p-3" }
const _hoisted_5 = {
  key: 0,
  "data-custom": "",
  class: "flex flex-wrap items-center gap-3 text-sm text-gray-700"
}
const _hoisted_6 = { class: "block" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "flex flex-wrap items-center gap-1.5" }
const _hoisted_9 = {
  key: 1,
  class: "m-0 text-[13px] text-red-600"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "mb-1 text-xs text-gray-500" }
const _hoisted_12 = {
  "data-preview": "",
  class: "max-w-[340px] whitespace-pre-wrap break-words rounded-2xl rounded-bl-sm bg-[#f3f4f6] px-3 py-2 text-sm leading-5 text-gray-900"
}
const _hoisted_13 = ["aria-pressed"]

import { computed } from 'vue'

import SelectInput from '@/components/neue/SelectInput.vue'
import NumberStepper from '@/components/neue/wizard/NumberStepper.vue'
import WizardIcon from '@/components/neue/wizard/WizardIcon.vue'
import { CUSTOM_DAYS_MAX, HOURS, REMINDER_WHENS, reminderBody } from '@/config/dropWizardSteps'

const SEGMENT = 153


export default {
  __name: 'ReminderCard',
  props: {
  reminder: { type: Object, required: true },
  index: { type: Number, required: true },
  data: { type: Object, required: true },
  sendsAtLabel: { type: String, default: '' },
  skipReason: { type: String, default: '' },
  linkExample: { type: String, default: '' }
},
  emits: ['update', 'remove'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const body = computed(() => reminderBody(props.reminder, props.data))
const empty = computed(() => !body.value.trim())
const previewText = computed(() => `${body.value.replace(/\{\{first_name\}\}/g, 'Sam')}\n\n${props.linkExample}`.trim())
const count = computed(() => previewText.value.length)
const countLabel = computed(
  () => `${count.value} / 160${count.value > 160 ? ` · ${Math.ceil(count.value / SEGMENT)} texts` : ''}`
)

const insert = tag => emit('update', { body: `${body.value.replace(/\s*$/, '')} ${tag}`.trim() })

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["overflow-hidden rounded-lg border bg-white shadow-sm", empty.value ? 'border-red-300' : 'border-gray-300'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(WizardIcon, { name: "bell" })
      ]),
      _createElementVNode("span", _hoisted_3, "Reminder " + _toDisplayString(__props.index + 1), 1),
      _createVNode(SelectInput, {
        "model-value": __props.reminder.when,
        name: "When",
        options: _unref(REMINDER_WHENS),
        class: "min-w-[200px] flex-1",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (_ctx.$emit('update', { when: $event })))
      }, null, 8, ["model-value", "options"]),
      _createElementVNode("button", {
        type: "button",
        "data-remove": "",
        "aria-label": "Remove reminder",
        class: "rounded-md p-1 text-gray-400 hover:bg-red-50 hover:text-red-600",
        onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('remove')))
      }, [
        _createVNode(WizardIcon, { name: "x" })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (__props.reminder.when === 'custom')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(NumberStepper, {
              "model-value": __props.reminder.daysBefore,
              name: "Days before production",
              min: 0,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.$emit('update', { daysBefore: Math.min($event ?? 0, _unref(CUSTOM_DAYS_MAX)) })))
            }, null, 8, ["model-value"]),
            _createVNode(SelectInput, {
              "model-value": __props.reminder.time,
              name: "At",
              options: _unref(HOURS),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (_ctx.$emit('update', { time: $event })))
            }, null, 8, ["model-value", "options"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("label", _hoisted_6, [
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "mb-1 block text-[13px] font-medium text-gray-700" }, "Message", -1)),
        _createElementVNode("textarea", {
          value: body.value,
          rows: "3",
          class: _normalizeClass(["block w-full rounded-md border px-2.5 py-2 text-sm leading-5 text-gray-900 shadow-sm", empty.value ? 'border-red-400' : 'border-gray-300']),
          onInput: _cache[4] || (_cache[4] = $event => (_ctx.$emit('update', { body: $event.target.value })))
        }, null, 42, _hoisted_7)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-xs text-gray-500" }, "Insert", -1)),
        _createElementVNode("button", {
          type: "button",
          "data-insert": "first_name",
          class: "rounded-full border border-gray-300 bg-white px-2 py-0.5 text-xs font-medium text-gray-700 hover:bg-gray-100",
          onClick: _cache[5] || (_cache[5] = $event => (insert('{{first_name}}')))
        }, " First name "),
        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "flex-1" }, null, -1)),
        _createElementVNode("span", {
          "data-count": "",
          class: _normalizeClass(["text-xs tabular-nums", count.value > 160 ? 'text-[#b45309]' : 'text-gray-500'])
        }, _toDisplayString(countLabel.value), 3)
      ]),
      (empty.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Add the reminder text before continuing."))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[10] || (_cache[10] = _createTextVNode(" Preview ", -1)),
              (__props.sendsAtLabel)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode("· Sends " + _toDisplayString(__props.sendsAtLabel), 1)
                  ], 64))
                : (__props.skipReason === 'already-open')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("· Will not send: ordering is already open.")
                    ], 64))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, _toDisplayString(previewText.value), 1)
          ])),
      _createElementVNode("button", {
        type: "button",
        "data-vcard": "",
        "aria-pressed": __props.reminder.attachVcard,
        class: "inline-flex items-center gap-2 text-[13px] text-gray-700",
        onClick: _cache[6] || (_cache[6] = $event => (_ctx.$emit('update', { attachVcard: !__props.reminder.attachVcard })))
      }, [
        _createElementVNode("span", {
          class: _normalizeClass(["grid h-4 w-4 place-items-center rounded border", __props.reminder.attachVcard ? 'border-gray-900 bg-gray-900 text-white' : 'border-gray-300 bg-white'])
        }, [
          (__props.reminder.attachVcard)
            ? (_openBlock(), _createBlock(WizardIcon, {
                key: 0,
                name: "check"
              }))
            : _createCommentVNode("", true)
        ], 2),
        _cache[11] || (_cache[11] = _createTextVNode(" Attach my contact card ", -1))
      ], 8, _hoisted_13)
    ])
  ], 2))
}
}

}